import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { RootState } from '../store';

const url = process.env.REACT_APP_API_URL;
const rtkBaseUrl = url?.slice(0, url?.lastIndexOf('/api'));

//docs: https://redux-toolkit.js.org/rtk-query/usage/code-splitting
export const rootApi = createApi({
    reducerPath: 'api',
    baseQuery: fetchBaseQuery({
        baseUrl: rtkBaseUrl,
        timeout: 30000,
        credentials: 'include',
        prepareHeaders: (headers, { getState }) => {
            const token =
                sessionStorage.getItem('token') ||
                localStorage.getItem('token') ||
                (getState() as RootState).auth.signInData.token;
            headers.set('Authorization', `Bearer ${token}`);
            return headers;
        },
    }),
    endpoints: () => ({}),
    tagTypes: [],
});

export interface BaseOdataQueryApiArg {
    filter?: string;
    orderBy?: string;
    top?: number;
    skip?: number;
}

export interface BaseOdataInfiniteQueryApiArg {
    top?: number;
    skip?: number;
}
